module.exports = __webpack_public_path__ + "static/media/fotapressa.844a1638.png";